/* eslint-disable wc/guard-super-call */
import { html } from 'lit';
import { MobxLitElement } from '@adobe/lit-mobx';
import { query, customElement, property, state } from 'lit/decorators.js';
import '@digital-realty/ix-icon-button/ix-icon-button.js';
import { computePosition } from '@floating-ui/dom';
import { classMap } from 'lit/directives/class-map.js';
import { TWStyles } from '../../tw.js';
import { NotificationsStyle } from '../../styles/notifications-style.js';

// Tooltip code, to be replaced with a generic component
@customElement('notification-tooltip')
export class NotificationTooltip extends MobxLitElement {
  static get styles() {
    return [TWStyles, NotificationsStyle];
  }

  @query('.notification-tooltip') notificationTooltip!: HTMLDivElement;

  @property({ type: Boolean, reflect: true }) isVisible: boolean = false;

  @property({ type: String, reflect: true }) label: string = '';

  @state() hoveredElement: HTMLElement | undefined = undefined;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(
      'show-notification-tooltip',
      this.configureNotificationTooltip
    );
    window.addEventListener(
      'hide-notification-tooltip',
      this.hideNotificationTooltip
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(
      'show-notification-tooltip',
      this.configureNotificationTooltip
    );
    window.removeEventListener(
      'hide-notification-tooltip',
      this.hideNotificationTooltip
    );
  }

  configureNotificationTooltip = (e: any) => {
    const { label, target } = e.detail;
    this.hoveredElement = target as HTMLElement;
    this.label = label;
    this.isVisible = true;
  };

  hideNotificationTooltip = () => {
    this.isVisible = false;
    this.hoveredElement = undefined;
    this.label = '';
  };

  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has('hoveredElement') && this.isVisible) {
      if (this.hoveredElement) {
        computePosition(this.hoveredElement, this.notificationTooltip, {
          placement: 'bottom-end',
        }).then(({ x, y }) => {
          this.notificationTooltip.style.left = `${x}px`;
          this.notificationTooltip.style.top = `${y + 12}px`;
        });
      }
    }
  }

  render() {
    const classes = {
      hidden: !this.isVisible,
    };

    return html`<div
        class="notification-tooltip z-[9999] rounded absolute p-2 white-text ${classMap(
          classes
        )}"
      >
        ${this.label}
      </div>
      <slot></slot>`;
  }
}
